<div>
    <label for="password">{{ label }}<span class="text-danger font-weight-bolder h3"> *</span></label>
    <input type="password" class="form-control" [value]="password" (input)="onInput($event)" (click)="capsLockEvent($event)" />
    <span *ngIf="showCapsLockWarning && capsLockOn" class="badge rounded-pill bg-warning text-white mt-1">Caps lock on</span>
</div>
